/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

import mergeClassName from 'merge-class-names';

import { createUseStyles, createUseColoredStyles } from '../../palette';
import decorate from '../../common/utils/decorate';
import useId from '../../common/hooks/useId';

const useMainStyles = createUseStyles((theme) => ({
  container: {
    display: 'inline-block'
  },

  checkbox: {
    display: 'none',

    '& ~ label': {
      ...theme.standarts('checkbox'),

      cursor: 'pointer',
      display: 'flex',
      alignItems: 'flex-start',
      gap: theme.getFactor('checkbox', 'indent', 0.5)
    },

    '& ~ label:before': {
      color: 'transparent',
      transition: 'border-width 0.1s linear, background-color 0.1s linear, color 0.1s linear',

      content: '"==="',
      boxSizing: 'border-box',
      display: 'block',
      borderStyle: 'solid',
      borderWidth: 1
    },

    '&:disabled ~ label:before': {
      borderColor: theme.getColor('checkbox', 'disabled', 'value')
    }
  },

  children: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column'
  }
}));

const useVariantStylesMap = createUseColoredStyles((theme, color) => ({
  checkbox: {
    '& ~ label:before': {
      content: '""',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderColor: theme.getColor('checkbox', color, 'value')
    },
    
    '&:checked ~ label:before': {
      backgroundColor: theme.getColor('checkbox', color, 'value'),
      color: theme.getColor('checkbox', color, 'contrast'),
      fontWeight: 'bold',
      
      content: '"✓"',
      borderStyle: 'none'
    }
  },

  radio: {
    '& ~ label:before': {
      borderRadius: '50%',
      borderColor: theme.getColor('checkbox', color, 'value')
    }
  }
}));

const useSizeStyles = createUseStyles((theme) => ({
  small: {
    '& ~ label:before': {
      fontSize: 6,
      
      marginTop: 2,
      
      width: 10,
      height: 10
    },

    '&:checked ~ label:before': {
      borderWidth: 3
    }
  },

  middle: {
    '& ~ label:before': {
      fontSize: 10,
      
      marginTop: 1.5,
      
      width: 15,
      height: 15
    },

    '&:checked ~ label:before': {
      borderWidth: 4
    }
  },

  large: {
    '& ~ label:before': {
      fontSize: 14,
      
      marginTop: 0,
      
      width: 20,
      height: 20
    },

    '&:checked ~ label:before': {
      borderWidth: 5
    }
  }
}));

export default decorate(
  class extends React.PureComponent {
    static decorateWith = {
      id: (props) => props.id || 'checkbox' + useId() + 'input',
      classes: {
        main: useMainStyles,
        variant: useVariantStylesMap,
        size: useSizeStyles
      }
    };

    static propTypes = {
      variant: PropTypes.string.isRequired,
      size: PropTypes.string.isRequired
    };

    static defaultProps = {
      variant: 'checkbox',
      color: 'primary',
      size: 'middle'
    };

    constructor(props) {
      super(props);
    }

    componentDidMount() {}

    componentWillUnmount() {}

    componentDidUpdate(prevProps, prevState, snapshot) {}

    render() {
      const {
        classes,
        children,
        variant,
        color,
        size,
        id,
        className,
        containerClassName,
        childrenClassName,
        startAdornment,
        endAdornment,
        ...props
      } = this.props;

      const mergedClassName = mergeClassName(
        className,
        classes.main.checkbox,
        (classes.variant[color] ?? classes.variant.basic)[variant],
        size && classes.size[size]
      );

      return (
        <div className={mergeClassName(containerClassName, classes.main.container)}>
          <input
            type={variant === 'radio' ? 'radio' : 'checkbox'}
            {...props}
            id={id}
            className={mergedClassName}
          />
          <label htmlFor={id}>
            {startAdornment}
            <div className={mergeClassName(childrenClassName, classes.main.children)}>{children}</div>
            {endAdornment}
          </label>
        </div>
      );
    }
  }
);
